import { Button, HStack, Text } from '@chakra-ui/react';

export type BuildInfoProps = {
    /** Environment label — the Vite mode of the running build. */
    environment: string;
    /** Full commit sha; absent on local dev builds. */
    sha?: string;
    /** Commit permalink; when present the short sha renders as a link. */
    commitUrl?: string;
};

/** One-line build stamp: `<environment> · <shortsha>`. */
export function BuildInfo({ environment, sha, commitUrl }: BuildInfoProps) {
    const shortSha = sha?.slice(0, 7);
    return (
        <HStack gap={1}>
            <Text fontSize='sm' fontFamily='mono' color='fg.muted'>
                {environment}
                {shortSha && !commitUrl && (
                    <span title={sha}> · {shortSha}</span>
                )}
                {shortSha && commitUrl && ' ·'}
            </Text>
            {shortSha && commitUrl && (
                <Button
                    asChild
                    variant='ghost'
                    size='xs'
                    h={6}
                    px={1.5}
                    fontSize='sm'
                    fontFamily='mono'
                    color='fg.muted'
                >
                    <a
                        href={commitUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        title={sha}
                    >
                        {shortSha}
                    </a>
                </Button>
            )}
        </HStack>
    );
}
